import { HeaderBasic } from "@components/site/HeaderBasic"
import { Button } from "@components/ui/Button"
import { ContentBlocks } from "eddev/blocks"
import { useAppData } from "eddev/hooks"
import { Link } from "eddev/routing"
import { defineView } from "eddev/views"

export default defineView("_error", (props) => {
  return (
    <div>
      <div className="grid-auto">
        <HeaderBasic title="Page not found">
          <p>Oops! It looks like you've landed on a page that no longer exists.</p>
          <p>
            <Link href="/">
              <Button>Take me to the homepage</Button>
            </Link>
          </p>
        </HeaderBasic>
      </div>
      <ContentBlocks blocks={props.templateParts?.siteFooter?.contentBlocks} />
    </div>
  )
})
